<template>
  <ul class="article-lists">
      <li v-for="(item,index) in articleLists" :key="index" class="article-item" @click="getArticleDetail(item)">
        <ArticleThumbnail :content="item.content" class="img-pic" :title="item.title"></ArticleThumbnail>
        <div class="article-content">
          <h3 class="article-header">
            {{item.title}}
          </h3>
          <section class="relevant-line">
            <p class="read">
              <img src="@/assets/images/m_faq_articles_read@3x.png" alt="">
              <span>{{item.custom_fields.post_views_count[0] | readparse}}</span>
            </p>
            <p class="time">
              <img src="@/assets/images/m_faq_articles_time@3x.png" alt="">
              <span>{{item.date | dateparse}}</span>
            </p>
          </section>
        </div>
      </li>
  </ul>
</template>

<script>
import ArticleThumbnail from './ArticleThumbnail'

export default {
  name:"articleitem",
  props:['articleLists'],
  components:{
    ArticleThumbnail,//缩略图
  },
  methods:{
    getArticleDetail(item){
      this.$router.push({
        name:'articlepage',
        query: { id : item.id }
      })
    }
  },
  filters:{
    dateparse(val){
      var dateArr = val.split(" ")
      return dateArr[0]
    },
    readparse(val){
      if(val>1000000){
        return "10万+";
      }else{
        return val;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../assets/css/base.scss';
  .article-lists {
    width: px2vw(355px);
    margin: 0 auto;
    .article-item {
        padding: pxtorem(10px) pxtorem(10px) pxtorem(5px) pxtorem(10px);
        display: flex;
        position: relative;
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 4px 0px rgba(0,0,0,0.1);
        border-radius:pxtorem(6px);
        cursor: pointer;
        .icon_wrapper{
          img{
            height: pxtorem(31px);
            position: absolute;
            top:pxtorem(10px);
            left: pxtorem(-8px);

          }
        }
        .title{
            font-size:pxtorem(16px);
            color:rgba(26,26,26,1);
        }
        .content{
          font-size:pxtorem(13px);
          color:rgba(89,89,89,1);
          line-height: pxtorem(19px);
          margin-top:pxtorem(13px);
        }
        &+.article-item{
          margin-top:pxtorem(10px);
        }
        .article-content {
            flex: 1;
            padding-left: pxtorem(12px);
            .article-header {
                font-weight: normal;
                color: rgba(26, 26, 26, 1);
                font-size: pxtorem(16px);
                line-height: pxtorem(22px);
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                height: pxtorem(44px);
            }
        }
    }
    .relevant-line {
        color: rgba(191, 191, 191, 1);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: pxtorem(24px);
        .read {
            display: flex;
            align-items: center;
            max-width: pxtorem(100px);
            overflow: hidden;
            img {
                width: pxtorem(26px);
            }
        }
        .time {
            display: flex;
            align-items: center;
            margin-left: pxtorem(4px);
            img {
                width: pxtorem(22px);
            }
        }
    }
    .img-pic {
        width: pxtorem(90px);
        height: pxtorem(66px);
        border: 1px solid #EDEDED;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/ArticleItem.vue